(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/spelpaus/assets/javascripts/views/suspension.js') >= 0) return;  svs.modules.push('/modules/spelpaus/assets/javascripts/views/suspension.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.spelpaus.views.Suspension = Marionette.View.extend({
    template: function(data) {
      data.viewData = {
        rerender: this.getOption('preRendered') || !this.first,
        pageTitle: this.getOption('pageTitle'),
        backLinkText: this.getOption('backLinkText'),
        backLinkUrl: this.getOption('backLinkUrl'),
        backLink: this.getOption('backLink')
      };
      this.first = false;
      return svs.spelpaus.templates.suspension(data);
    },
    regions: {
      activePausesRegion: '#activePausesRegion',
      suspensionHistoryRegion: '#suspensionHistoryRegion',
      suspensionFormRegion: '#suspensionFormRegion',
      spelpausInfoRegion: '#spelpausInfoRegion'
    },
    behaviors: {
      ServerSideRendering: {
        regionSetup: function() {
          return {
            activePausesRegion: {
              view: svs.spelpaus.views.ActiveSuspensions,
              options: {
                model: this.model
              }
            },
            suspensionFormRegion: {
              view: svs.spelpaus.views.SuspensionForm,
              options: {
                model: this.model
              }
            },
            suspensionHistoryRegion: {
              view: svs.spelpaus.views.SuspensionHistory,
              options: {
                model: this.model,
                collection: this.model.get('suspensionHistory')
              }
            },
            spelpausInfoRegion: {
              view: svs.spelpaus.views.Info
            }
          };
        }
      }
    },
    events: {
      'click .js-pul-link': 'onClickPulTerms'
    },
    initialize: function() {
      this.first = true;
      this.listenToOnce(this.model.get('suspensionHistory'), 'add', this.renderIfFirst);
    },
    renderIfFirst: function() {
      if (this.model.get('suspensionHistory').size() === 1) {
        this.render();
      }
    },
    onClickPulTerms: function(e) {
      e.preventDefault();
      svs.components.Modal.show(
        svs.spelpaus.templates.pulterms(),
        {},
        {
          title: 'VILLKOR',
          leftButton: { text: 'Stäng' },
          doubleWidth: !svs.core.detect.formfactor.mobile(),
          rightButton: { visible: false }
        }
      );
    }
  });
})(Backbone, _, svs);

 })(window);